export const ADD_TO_CART = "ADD_TO_CART"
export const TAKEAWAY_FROM_CART = "TAKEAWAY_FROM_CART"
export const REMOVE_FROM_CART = "REMOVE_FROM_CART"
export const SIGN_IN = "SIGN_IN"
export const SIGN_OUT = "SIGN_OUT"

